function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41.67 39.41"
}, props), React.createElement("path", {
  d: "M8.98 9.19l4.73 4.73M1.77 19.96h8.5M8.88 31.42l4.73-4.73m6.97 10.95v-8.5m0-18.87v-8.5M32.3 31.42l-4.73-4.73m12.33-6.73h-8.5m1-10.77l-4.73 4.73",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: "10",
  strokeWidth: "3.54"
})));